module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjMzMzMgNS4zMzMxN0wxNC44MzMzIDQuNDk5ODRWMTIuODMzMk0xLjUgMS4xNjY1VjYuOTk5ODRNMS41IDYuOTk5ODRWMTIuODMzMk0xLjUgNi45OTk4NEg4LjE2NjY3TTguMTY2NjcgNi45OTk4NFYxLjE2NjVNOC4xNjY2NyA2Ljk5OTg0VjEyLjgzMzIiIHN0cm9rZT0iIzFBODVFNCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/text-label/h1-active.svg
// module id = 7pIs
// module chunks = 46